export const KEYCHAIN_URL = "https://x.cartridge.gg";
export const RPC_SEPOLIA = "https://api.cartridge.gg/x/starknet/sepolia";
export const RPC_MAINNET = "https://api.cartridge.gg/x/starknet/mainnet";
//# sourceMappingURL=constants.js.map